import { Injectable, inject } from '@angular/core';
import { ApiService } from '@us/web/shared/data-access';

@Injectable({
    providedIn: 'root'
})
export class VerifyShopService {
    private readonly apiService = inject(ApiService);

    public getShopIdByTableId(params: { table_id: number }) {
        return this.apiService.get<{ shop_id: string }>('shop/get-shop-id-by-table-id', { params });
    }
}
